import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Reveal, Etiqueta } from '../../brand'
import { SUITE_ROUTES } from '../../brand/templates/routes'
import { trackMenuClick } from '../../utils/analytics'

const STATE: Record<string, 'construcao' | 'conexao' | 'cura'> = { genesis: 'construcao', connect: 'conexao', autoCare: 'cura' }

/** Três peças, um laço: Genesis em cartão grande, Connect e Auto Care ao lado (modelo do Ângelo). Copy vem de brand.pages.*. */
export function SuiteCards({ location = 'home', exclude }: { location?: string; exclude?: string }) {
  const { t } = useTranslation()
  const items = SUITE_ROUTES.filter((r) => r.slug !== exclude)
  const card = (slug: string, to: string, grande?: boolean) => (
    <Link key={to} to={to} className={['z-pcard', grande && 'z-pcard--grande'].filter(Boolean).join(' ')} data-state={STATE[slug]} onClick={() => trackMenuClick(to, location)}>
      <div>
        <Etiqueta as="p">{t(`brand.pages.${slug}.kicker`)}</Etiqueta>
        <p className="z-pcard__tag">{t(`brand.pages.${slug}.title`)}</p>
        <p className="z-pcard__corpo">{t(`brand.pages.${slug}.lede`)}</p>
      </div>
      <span className="z-pcard__link">{t('model.suite.know', { name: t(`header.${slug}`) })}</span>
    </Link>
  )
  if (exclude) return <Reveal as="div" stagger={0.1} y={14} className="z-field z-field--2">{items.map((r) => card(r.slug, r.to))}</Reveal>
  const [first, ...rest] = items
  return (
    <Reveal as="div" stagger={0.12} y={16} className="z-suite">
      {card(first.slug, first.to, true)}
      <div className="z-suite__coluna">{rest.map((r) => card(r.slug, r.to))}</div>
    </Reveal>
  )
}

/** Faixa de três links com a tagline de cada peça (topo da página Plataforma). */
export function ProductStrip() {
  const { t } = useTranslation()
  return (
    <Reveal as="ul" stagger={0.08} y={10} className="z-strip">
      {SUITE_ROUTES.map((r) => (
        <li key={r.to}>
          <Link to={r.to} className="z-strip__link" onClick={() => trackMenuClick(r.to, 'platform-strip')}>
            <span><p className="z-strip__nome">{t(`header.${r.slug}`)}</p><p className="z-strip__tag" data-state={STATE[r.slug]}>{t(`brand.pages.${r.slug}.title`)}</p></span>
            <span className="z-strip__seta" aria-hidden="true">→</span>
          </Link>
        </li>
      ))}
    </Reveal>
  )
}
